(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flash-sales-ofertas"] && !Shopify.designMode) return;
  try {
    
class FlashSaleSection extends HTMLElement {
  constructor() {
    super();
    this.grid = this.querySelector('[data-flash-sale-grid]');
    this.hoursEl = this.querySelector('[data-count-hours]');
    this.minutesEl = this.querySelector('[data-count-minutes]');
    this.secondsEl = this.querySelector('[data-count-seconds]');
    this.feedbackEl = this.querySelector('[data-cart-feedback]');
    this.cards = Array.from(this.querySelectorAll('[data-flash-sale-card]'));
    this.rotationHours = parseFloat(this.dataset.rotationHours) || 3;
    this.productsToShow = parseInt(this.dataset.productsToShow, 10) || 6;
    this.customerId = this.dataset.customerId || '';
    this.tickHandle = null;
  }

  connectedCallback() {
    this.userSeed = this.getUserSeed();
    this.renderRotation();
    this.startCountdown();
    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-add-to-cart]');
      if (button) this.handleAddToCart(button);
    });
  }

  disconnectedCallback() {
    if (this.tickHandle) window.clearInterval(this.tickHandle);
  }

  getUserSeed() {
    if (this.customerId) return 'customer:' + this.customerId;
    const storageKey = 'flash_sale_uid';
    try {
      let uid = window.localStorage.getItem(storageKey);
      if (!uid) {
        uid = (window.crypto && window.crypto.randomUUID)
          ? window.crypto.randomUUID()
          : 'uid-' + Math.random().toString(36).slice(2) + Date.now();
        window.localStorage.setItem(storageKey, uid);
      }
      return uid;
    } catch (error) {
      return 'session:' + Math.random().toString(36).slice(2);
    }
  }

  hashString(value) {
    let hash = 2166136261;
    for (let i = 0; i < value.length; i += 1) {
      hash ^= value.charCodeAt(i);
      hash = Math.imul(hash, 16777619);
    }
    return hash >>> 0;
  }

  mulberry32(seed) {
    let a = seed;
    return function random() {
      a |= 0;
      a = (a + 0x6D2B79F5) | 0;
      let t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }

  getEpoch() {
    const rotationMs = this.rotationHours * 60 * 60 * 1000;
    return Math.floor(Date.now() / rotationMs);
  }

  getEpochBoundary(epoch) {
    const rotationMs = this.rotationHours * 60 * 60 * 1000;
    return (epoch + 1) * rotationMs;
  }

  pickIndexes(poolSize, count, epoch) {
    const seedString = this.userSeed + ':' + epoch;
    const seedNumber = this.hashString(seedString);
    const random = this.mulberry32(seedNumber);
    const indexes = Array.from({ length: poolSize }, (_, i) => i);
    for (let i = indexes.length - 1; i > 0; i -= 1) {
      const j = Math.floor(random() * (i + 1));
      [indexes[i], indexes[j]] = [indexes[j], indexes[i]];
    }
    return indexes.slice(0, Math.min(count, poolSize));
  }

  renderRotation() {
    if (!this.cards.length) return;
    const epoch = this.getEpoch();
    const selected = this.pickIndexes(this.cards.length, this.productsToShow, epoch);
    const selectedSet = new Set(selected);
    this.cards.forEach((card, index) => {
      card.hidden = !selectedSet.has(index);
    });
    this.currentEpoch = epoch;
  }

  startCountdown() {
    const update = () => {
      const epoch = this.getEpoch();
      if (this.currentEpoch !== undefined && epoch !== this.currentEpoch) {
        this.renderRotation();
      }
      const boundary = this.getEpochBoundary(epoch);
      const remainingMs = Math.max(0, boundary - Date.now());
      const totalSeconds = Math.floor(remainingMs / 1000);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      const pad = (n) => String(n).padStart(2, '0');
      if (this.hoursEl) this.hoursEl.textContent = pad(hours);
      if (this.minutesEl) this.minutesEl.textContent = pad(minutes);
      if (this.secondsEl) this.secondsEl.textContent = pad(seconds);
    };
    update();
    this.tickHandle = window.setInterval(update, 1000);
  }

  async handleAddToCart(button) {
    const variantId = button.dataset.variantId;
    if (!variantId || button.disabled) return;
    button.dataset.loading = 'true';
    const originalHtml = button.innerHTML;
    button.disabled = true;
    try {
      const response = await fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }),
      });
      if (!response.ok) throw new Error('add_to_cart_failed');
      const cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const cartResponse = await fetch(cartRoot + 'cart.js', { headers: { Accept: 'application/json' } });
      const cart = await cartResponse.json();
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart } }));
      if (this.feedbackEl) {
        this.feedbackEl.textContent = this.dataset.successMessage || 'Producto agregado al carrito con descuento aplicado';
        window.setTimeout(() => {
          if (this.feedbackEl) this.feedbackEl.textContent = '';
        }, 4000);
      }
    } catch (error) {
      if (this.feedbackEl) {
        this.feedbackEl.textContent = 'No se pudo agregar el producto. Intentá de nuevo.';
      }
    } finally {
      button.disabled = false;
      button.innerHTML = originalHtml;
      delete button.dataset.loading;
    }
  }
}

if (!customElements.get('flash-sale-section')) {
  customElements.define('flash-sale-section', FlashSaleSection);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ici-cuadricula"] && !Shopify.designMode) return;
  try {
    
class MostWantedSection extends HTMLElement {
  connectedCallback() {
    this.feedbackTimeout = null;
    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-add-to-cart]');
      if (button) this.handleAddToCart(button);
    });
  }

  async handleAddToCart(button) {
    const variantId = button.dataset.variantId;
    if (!variantId || button.disabled) return;
    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = '...';
    try {
      const routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const response = await fetch(routeRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }),
      });
      if (!response.ok) throw new Error('add_to_cart_failed');
      const cartResponse = await fetch(routeRoot + 'cart.js', { headers: { Accept: 'application/json' } });
      const cart = await cartResponse.json();
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart } }));
      button.textContent = '✓';
    } catch (error) {
      button.textContent = 'Error';
    } finally {
      window.setTimeout(() => {
        button.disabled = false;
        button.textContent = originalText;
      }, 1500);
    }
  }
}

if (!customElements.get('most-wanted-section')) {
  customElements.define('most-wanted-section', MostWantedSection);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ici-nav-arbol"] && !Shopify.designMode) return;
  try {
    
/* ICI NAV-2 v2 (2026-09-28) — carrusel, filas en movimiento, rotación de imagen, reloj Flash y medición Clarity.
   Un solo botón ❚❚ pausa todo (WCAG 2.2.2). Todo se detiene fuera de pantalla, con la pestaña oculta,
   al pasar el mouse o tocar, y arranca en pausa con «reducir movimiento». */
(function () {
  'use strict';
  if (window.__iciNav2) return;
  window.__iciNav2 = true;
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  function ev(name) { try { if (window.clarity) window.clarity('event', name); } catch (e) {} }
  function onVisible(el, cb, th) {
    if (!('IntersectionObserver' in window)) { cb(true); return; }
    new IntersectionObserver(function (es) { cb(es[0].isIntersecting); }, { threshold: th || 0.3 }).observe(el);
  }

  /* Carrusel principal: avanza una tarjeta cada N s (categorías / subcategorías / departamentos). */
  function initTrack(root) {
    var track = root.querySelector('[data-icinav2-track]');
    if (!track) return function () { return false; };
    var prev = root.querySelector('[data-icinav2-prev]');
    var next = root.querySelector('[data-icinav2-next]');
    var every = (parseInt(root.getAttribute('data-interval'), 10) || 4) * 1000;
    var hover = false, visible = false, holdUntil = 0;

    function scrollable() { return track.scrollWidth > track.clientWidth + 8; }
    function step() {
      var card = track.querySelector('.icinav2__card');
      if (!card) return 160;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 12;
      return card.getBoundingClientRect().width + gap;
    }
    function atEnd() { return track.scrollLeft + track.clientWidth >= track.scrollWidth - 6; }
    function atStart() { return track.scrollLeft <= 6; }
    function go(dir) {
      if (dir > 0 && atEnd()) track.scrollTo({ left: 0 });
      else if (dir < 0 && atStart()) track.scrollTo({ left: track.scrollWidth });
      else track.scrollBy({ left: dir * step() });
    }
    function hold() { holdUntil = Date.now() + 9000; }
    if (prev) prev.addEventListener('click', function () { go(-1); hold(); ev('ici_nav2_control'); });
    if (next) next.addEventListener('click', function () { go(1); hold(); ev('ici_nav2_control'); });
    track.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hover = true; });
    track.addEventListener('pointerleave', function () { hover = false; });
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (t) { track.addEventListener(t, hold, { passive: true }); });
    track.addEventListener('focusin', function () { hover = true; });
    track.addEventListener('focusout', function () { hover = false; });
    onVisible(track, function (v) { visible = v; });

    var active = track.querySelector('.is-active');
    if (active && scrollable()) {
      try { track.scrollTo({ left: Math.max(0, active.offsetLeft - 8), behavior: 'instant' }); } catch (e) { track.scrollLeft = Math.max(0, active.offsetLeft - 8); }
      hold();
    }
    setInterval(function () {
      if (root.__paused || hover || !visible || document.hidden || Date.now() < holdUntil || !scrollable()) return;
      go(1);
    }, every);
    return scrollable;
  }

  /* Filas que se desplazan solas y de forma continua (~28 px/s); al llegar al final esperan
     y regresan al inicio. El usuario siempre manda: tocar, arrastrar o la rueda las detiene 6 s. */
  function initTicker(root, el) {
    var SPEED = 28;
    var pos = el.scrollLeft, last = 0, raf = 0, hover = false, visible = false, atEnd = false;
    var holdUntil = Date.now() + 2500;
    function max() { return el.scrollWidth - el.clientWidth; }
    function scrollable() { return max() > 8; }
    function hold(ms) { holdUntil = Date.now() + ms; }
    function frame(t) {
      raf = 0;
      if (!visible) { last = 0; return; }
      var dt = last ? Math.min(t - last, 64) : 0;
      last = t;
      var m = max(), now = Date.now();
      if (m <= 8 || root.__paused || hover || document.hidden || now < holdUntil) {
        pos = el.scrollLeft;
      } else if (atEnd) {
        atEnd = false;
        try { el.scrollTo({ left: 0, behavior: 'smooth' }); } catch (e) { el.scrollLeft = 0; }
        pos = 0;
        hold(1800);
      } else {
        pos += SPEED * dt / 1000;
        if (pos >= m - 0.5) { pos = m; atEnd = true; hold(1500); }
        el.scrollLeft = pos;
      }
      raf = requestAnimationFrame(frame);
    }
    function start() { if (!raf) { last = 0; raf = requestAnimationFrame(frame); } }
    el.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hover = true; });
    el.addEventListener('pointerleave', function () { hover = false; });
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (t) {
      el.addEventListener(t, function () { atEnd = false; hold(6000); }, { passive: true });
    });
    el.addEventListener('focusin', function () { hover = true; });
    el.addEventListener('focusout', function () { hover = false; });
    onVisible(el, function (v) { visible = v; if (v) start(); }, 0.1);
    document.addEventListener('visibilitychange', function () { if (!document.hidden && visible) start(); });
    return scrollable;
  }

  function initHero(root) {
    var hero = root.querySelector('[data-icinav2-hero]');
    if (!hero) return false;
    var slides = Array.prototype.slice.call(hero.querySelectorAll('.icinav2__slide'));
    if (slides.length < 2) return false;
    var dots = Array.prototype.slice.call(hero.querySelectorAll('.icinav2__dot'));
    var i = 0, hover = false, visible = true, holdUntil = 0;
    function load(k) {
      var img = slides[k] && slides[k].querySelector('img[data-src]');
      if (img) { img.src = img.getAttribute('data-src'); img.removeAttribute('data-src'); }
    }
    function show(n) {
      slides[i].classList.remove('is-on');
      slides[i].setAttribute('aria-hidden', 'true');
      i = (n + slides.length) % slides.length;
      load(i);
      load((i + 1) % slides.length);
      slides[i].classList.add('is-on');
      slides[i].removeAttribute('aria-hidden');
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    dots.forEach(function (d, k) {
      d.addEventListener('click', function (e) { e.preventDefault(); show(k); holdUntil = Date.now() + 12000; ev('ici_nav2_control'); });
    });
    hero.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hover = true; });
    hero.addEventListener('pointerleave', function () { hover = false; });
    hero.addEventListener('touchstart', function () { holdUntil = Date.now() + 9000; }, { passive: true });
    onVisible(hero, function (v) { visible = v; if (v) load(1); });
    setInterval(function () {
      if (root.__paused || hover || !visible || document.hidden || Date.now() < holdUntil) return;
      show(i + 1);
    }, 5000);
    return true;
  }

  function initTimer(root) {
    var out = root.querySelector('[data-icinav2-timer]');
    if (!out) return;
    var b = out.querySelector('b');
    function tick() {
      var h = document.querySelector('[data-count-hours]');
      var m = document.querySelector('[data-count-minutes]');
      var s = document.querySelector('[data-count-seconds]');
      if (!h || !m || !s) { out.hidden = true; return; }
      var t = [h, m, s].map(function (x) { return (x.textContent || '').trim(); });
      if (!t.join('') || /^0+$/.test(t.join(''))) { out.hidden = true; return; }
      b.textContent = t.join(':');
      out.hidden = false;
      var sec = h.closest('.shopify-section');
      if (sec && sec.id) out.setAttribute('href', '#' + sec.id);
    }
    tick();
    setInterval(tick, 1000);
  }

  function init(root) {
    if (!root || root.__icinav2) return;
    root.__icinav2 = true;
    root.__paused = root.getAttribute('data-autoplay') === 'false' || reduce;
    var pause = root.querySelector('[data-icinav2-pause]');
    var prev = root.querySelector('[data-icinav2-prev]');
    var next = root.querySelector('[data-icinav2-next]');
    var trackScrolls = initTrack(root);
    var tickers = Array.prototype.map.call(root.querySelectorAll('[data-icinav2-tick]'), function (el) { return initTicker(root, el); });
    var heroMoves = initHero(root);
    initTimer(root);

    function setPaused(p) {
      root.__paused = p;
      if (!pause) return;
      pause.classList.toggle('is-paused', p);
      pause.setAttribute('aria-pressed', p ? 'true' : 'false');
      pause.setAttribute('aria-label', p ? 'Reanudar movimiento' : 'Pausar movimiento');
    }
    function sync() {
      var s = trackScrolls();
      if (prev) prev.hidden = !s;
      if (next) next.hidden = !s;
      if (pause) pause.hidden = !(s || heroMoves || tickers.some(function (f) { return f(); }));
    }
    setPaused(root.__paused);
    if (pause) pause.addEventListener('click', function () { setPaused(!root.__paused); ev('ici_nav2_control'); });
    window.addEventListener('resize', sync);
    sync();

    root.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-ev]');
      if (a) ev(a.getAttribute('data-ev'));
    });
    var seen = false;
    onVisible(root, function (v) { if (v && !seen) { seen = true; ev('ici_nav2_visto'); } });
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-icinav2]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
